import { Box, Flex, Text, VStack } from '@chakra-ui/react';
import { StepTitle } from '../../v2qs/step-title';
import { StoreBadges } from '../../app-download';

export const DownloadAppStep: React.FC = () => {
  return (
    <Flex
      direction="column"
      align="center"
      minH="100vh"
      px={6}
      pt={16}
      pb={24}
      bg="white"
      overflowY="auto"
    >
      <VStack gap={5} maxW="500px" w="full">
        <StepTitle stepNumber={1} title="Download FrogBox Connect" />

        {/* Description */}
        <Box
          w="full"
          p={5}
          bg="gray.50"
          borderRadius="xl"
          border="1px solid"
          borderColor="gray.200"
        >
          <VStack align="flex-start" gap={4}>
            <Text fontSize="sm" color="gray.800" lineHeight="1.6">
              Use FrogBox Connect to remotely monitor battery life, adjust tilt
              and zoom and configure camera settings from your phone/tablet
              during a game.
            </Text>

            <Text fontSize="sm" color="gray.800" fontWeight="medium">
              Download{' '}
              <Text as="span" fontWeight="bold" color="green.600">
                FrogBox Connect
              </Text>{' '}
              (it's free!)
            </Text>

            <Box w="full" pt={4}>
              <StoreBadges size="lg" layout="horizontal" />
            </Box>
          </VStack>
        </Box>
      </VStack>
    </Flex>
  );
};
